import { useEffect } from 'react';

import { StorageManager } from '@atlas/core';

import { REGISTRATION_FLOW_ACTIVE_STORAGE_KEY } from 'common/constants';

const REGISTRATION_FLOW_ACTIVE_VALUE = 'active';

export const isRegistrationFlowActive = () =>
  StorageManager.getItem(REGISTRATION_FLOW_ACTIVE_STORAGE_KEY) === REGISTRATION_FLOW_ACTIVE_VALUE;

const useRegistrationFlowActive = ({ enabled = true } = {}) => {
  useEffect(() => {
    if (!enabled) {
      StorageManager.removeItem(REGISTRATION_FLOW_ACTIVE_STORAGE_KEY);
      return;
    }

    StorageManager.setItem(REGISTRATION_FLOW_ACTIVE_STORAGE_KEY, REGISTRATION_FLOW_ACTIVE_VALUE);

    return () => {
      StorageManager.removeItem(REGISTRATION_FLOW_ACTIVE_STORAGE_KEY);
    };
  }, [enabled]);
};

export default useRegistrationFlowActive;
